import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { ProfileComponent } from '../../profile/profile.component';
import { ProfileDropdownComponent } from '../../profile-dropdown/profile-dropdown.component';

@Component({
  standalone: true,
  selector: 'app-profile-panel',
  templateUrl: './profile-panel.component.html',
  styleUrls: ['./profile-panel.component.scss'],
  imports: [ProfileComponent, ProfileDropdownComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilePanelComponent {
  @Input() loadingMap?: string | null;
  public readonly dropdownVisible = signal<boolean>(false);

  // Closing on outside presses, entry selection and auth changes is handled by the dropdown itself.
  public onProfileToggleRequested(): void {
    this.dropdownVisible.update(visible => !visible);
  }
}
